// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__3tYUW","title":"tooltip_title__1lLcZ","content":"tooltip_content__1KUCB"};